import React from "react";
import imgRg from "../Resources/img/renta-garantizada.png";
import imgRinversion from "../Resources/img/card_271x163_ahorroprotegido@2x.png";
import imgVas from "../Resources/img/ahorro-seguro.png";
import imgRV from "../Resources/img/renta-vitalicia.png";
import imgIg from "../Resources/img/inversion-global.png";
import imgUc from "../Resources/img/ultra-cash.png";
import imgRVO from "../Resources/img/renta-vitalicia-oficiales.png";

import { useSelector } from "react-redux";
import { onlyProductAccess } from "../Utils/onlyProductAccess";
import List from "./list";
import { calcularEdad } from "../Utils/productos";

const CardTypeService = ({ item, openModal }) => {
  let img = "";

  switch (item.id) {
    case 0:
      img = imgVas;
      break;
    case 1:
      img = imgRg;
      break;
    case 2:
      img = imgRinversion;
      break;
    case 3:
      img = imgIg;
      break;
    case 4:
      img = imgUc;
      break;
    case 5:
      img = imgRV;
      break;
    case 6:
      img = imgRVO;
  }

  const recommendedProduct = useSelector((state) => state.recommended);

  const channel = useSelector((state) => state.login.channel);

  const assured = useSelector((state) => state.data.assured);

  const edadNacimiento = calcularEdad(assured.birthday);
  const validateEdad = edadNacimiento > item.anios_max;
  return (
    <div
      className={`cardTypeService ${
        recommendedProduct.recommended
          ? recommendedProduct.recommended.product === item.name
            ? "cardTypeService--recommended"
            : ""
          : ""
      } ${item.disabled || (validateEdad && "filter-gray")}`}
    >
      <div className="cardTypeService__container">
        <div className="cardTypeService--recommended__flag">
          <span>PRODUCTO RECOMENDADO</span>
        </div>
        <img src={img} alt="" className="cardTypeService__container__image" />
        <p className="cardTypeService__container__title">{item.title}</p>
        <div className="cardTypeService__container__body">
          <article className="cardTypeService__container__message">
            <List className="is-check">
              {item.messages.map((message, key) => {
                return <li key={key}>{message}</li>;
              })}
            </List>
          </article>
          <div className="cardTypeService__container__btn">
            {(assured !== undefined && Object.entries(assured).length) ||
            item.name === "rentaVitaliciaOficiales" ? (
              <button
                className="btn is-small"
                onClick={() => openModal(item.id)}
                disabled={
                  onlyProductAccess(channel, item.id) ||
                  item.disabled ||
                  validateEdad
                }
              >
                Cotizar
              </button>
            ) : (
              <button
                className="btn is-small"
                onClick={() => openModal(item.id)}
                disabled={true}
              >
                Cotizar
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardTypeService;
